import { render, staticRenderFns } from "./SubCategoryForm.vue?vue&type=template&id=31e767d8"
import script from "./SubCategoryForm.vue?vue&type=script&lang=js"
export * from "./SubCategoryForm.vue?vue&type=script&lang=js"
import style0 from "./SubCategoryForm.vue?vue&type=style&index=0&id=31e767d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports